import { createContext, useContext } from "react";
import { useAsync } from "@/lib/useAsync";
import { getFooter, getNavigation, getSiteSettings } from "@/lib/api";

const SiteContext = createContext({ nav: null, footer: null, settings: null, loading: true });

export function SiteProvider({ children }) {
  const nav = useAsync(getNavigation, []);
  const footer = useAsync(getFooter, []);
  const settings = useAsync(getSiteSettings, []);
  const loading = nav.loading || footer.loading || settings.loading;
  return (
    <SiteContext.Provider
      value={{
        nav: nav.data,
        footer: footer.data,
        settings: settings.data,
        loading,
        error: nav.error || footer.error || settings.error,
      }}
    >
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext);
}
